export function extractErrorMessage(
  error: unknown,
  defaultMessage = 'An error occurred'
): string {
  if (typeof error === 'string') {
    return error
  }

  if (typeof error !== 'object' || error === null) {
    return defaultMessage
  }

  const err = error as Record<string, unknown>

  // Check error.response.data (AxiosError format)
  if (typeof err.response === 'object' && err.response !== null) {
    const response = err.response as Record<string, unknown>
    if (typeof response.data === 'object' && response.data !== null) {
      const data = response.data as Record<string, unknown>

      if (typeof data.message === 'string') {
        return data.message
      }

      if (typeof data.detail === 'string') {
        return data.detail
      }

      if (typeof data.error === 'string') {
        return data.error
      }

      if (
        typeof data.error === 'object' &&
        data.error !== null &&
        'message' in data.error &&
        typeof data.error.message === 'string'
      ) {
        return data.error.message
      }
    }
  }

  // Check if error.data contains the API response (RTK Query format)
  if (err.data) {
    if (typeof err.data === 'string') {
      return err.data
    }

    if (typeof err.data === 'object' && err.data !== null) {
      const data = err.data as Record<string, unknown>

      if (typeof data.message === 'string') {
        return data.message
      }

      if (typeof data.detail === 'string') {
        return data.detail
      }

      if (typeof data.error === 'string') {
        return data.error
      }

      if (
        typeof data.error === 'object' &&
        data.error !== null &&
        'message' in data.error &&
        typeof data.error.message === 'string'
      ) {
        return data.error.message
      }
    }
  }

  // Try top-level message (skip generic Axios messages)
  if (
    typeof err.message === 'string' &&
    !err.message.includes('Request failed')
  ) {
    return err.message
  }

  // Try detail property
  if (typeof err.detail === 'string') {
    return err.detail
  }

  if (typeof err.error === 'string') {
    return err.error
  }

  return defaultMessage
}
